import styled from 'astroturf/react';
import Svg from 'src/components/Svg';
import Button from 'src/components/Button';

const Page = styled('div')`
  display: block;
  @media screen and (max-width: 600px) {
    height: 100%;
  }
`;

const Container = styled('div')`
  position: relative;
  overflow: auto;
  @media screen and (max-width: 600px) {
    height: 100%;
  }
`;

const ContainerInner = styled('div')`
  position: relative;
  padding: 10px;
  height: 100vh;

  @media screen and (max-width: 600px) {
    height: 100%;
  }
`;

const FullHeightContent = styled('div')`
  position: absolute;
  max-height: 90vh;
  top: 50%;
  left: 10%;
  right: 10%;
  overflow-y: auto;
  background: #fff;
  border-radius: 20px;
  padding: 40px 50px 45px;
  transform: translateY(-50%);

  @media screen and (max-width: 600px) {
    transform: none;
    height: calc(100svh - 40px);
    max-height: calc(100svh - 40px);
    padding: 20px 0 20px 30px;
    overflow-y: unset;
    left: 0px;
    right: 0px;
    top: 10px;
    position: relative;
    & > div{
      height: 100%;
    }
  }

  div[role='progressbar'] > div {
    border: 1px solid #ccc;
  }
`;

const Ack = styled('div')`
  text-align: left;
`;

const AckInner = styled('div')`
  padding: 20px;

  &.overflow-hidden {
    overflow: hidden;
  }
`;

const AckInnerLabel = styled('div')`
  font-size: 3rem;
  line-height: 1.2;

  &.space-below {
    margin-bottom: 20px;
  }

  &.space-above {
    margin-top: 20px;
  }
`;

const AckLogoContainer = styled('div')`
  display: flex;
  justify-content: center;
  height: 1.8cm;
`;

const AckLogo = styled(Svg)`
  width: 350px;
  height: fit-content;
`;

const HeaderWrapper = styled('div')`
  margin: 0 0 20px;
`;

const QuestionWrapper = styled('div')`
  margin: 30px 0;
`;
const PublicSurveyContentContainer = styled('div')`
@media screen and (max-width: 600px) {
    height: 100%;
    max-height: calc(95% - 40px);
    overflow-y: auto;
    margin-bottom: 10px;
    & > div{
      padding-right: 30px; 
    }
  }
`;
const FooterButtonsWrapper = styled('div')`
@media screen and (max-width: 600px) {
    width: calc(100%);
    position: absolute;
    bottom: 0;
    left: 0;
    background: #FFFFFF;
    border-top: 2px solid #ccc;
    border-radius: 0 0 20px 20px;
}
`;


const ButtonsWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 600px) {
    margin: 10px 30px;
  }

  & > div {
    flex: 0 0 50%;
  }

  & > div:last-child {
    text-align: right;
  }
`;

const ContentContainer = styled('div')`
  display: flex;
  flex-direction: column;
  
  @media screen and (max-width: 600px) {
    height: 100%;
    &.addPaddingRight{
      margin-right: 30px;
    }
  }
`;

const LanguageSelectContainer = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const LanguageSelectWrapper = styled('div')`
  width: 150px;
  float: right;

  @media screen and (max-width: 600px) {
    width: 100px;
  }
`;

const SurveyActionLogo = styled(Svg)`
  width: 20px;
  height: 20px;
`;

const SurveyActionButton = styled(Button)`
  padding: 0 10px;
`;

const RadioGroupInput = styled('input')`
  opacity: 0;
  position: absolute;
  z-index: -1;
  width: 16px;
  height: 16px;

  &:checked + [class*='RadioGroupCircle'] {
    border: solid 5px var(--ph-light-blue-500);
    border-color: var(--ph-light-blue-500);
  }
`;

const RadioGroupCircle = styled('div')`
  width: 16px;
  height: 16px;
  margin-right: 12px;
  border: 1px solid rgba(var(--ph-gray-rgb-500), 0.4);
  border-radius: 50%;
  background-color: var(--white);
  cursor: pointer;
`;

const RadioGroupText = styled('span')`
  font-size: var(--ph-text-md);
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  color: var(--charcoal-grey);
`;

const RadioGroupItem = styled('label')`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 3px;
`;

const RadioGroupItemRow = styled('div')`
  display: inline-block;
`;

const LanguageContainer = styled('div')`
  display: flex;
  flex-direction: column;

  &.items-center {
    align-items: center;
  }

  &.space-around {
    padding: 30px 0px 60px;
  }
  @media screen and (max-width: 600px) {
    height: 100%;
    max-height: calc(95% - 40px);
    overflow-y: auto;
    margin-bottom: 10px;
    margin-right: 30px;
  }
`;

const LanguageLabel = styled('label')`
  font-size: var(--ph-text-lg);
  margin-bottom: 16px;
`;

const LanguageBtnContainer = styled('div')`
  display: flex;
  justify-content: center;  
  @media screen and (max-width: 600px) {
    margin: 10px 30px;
  }
`;

export default {
  Page,
  Container,
  ContainerInner,
  FullHeightContent,
  Ack,
  AckInner,
  AckLogoContainer,
  AckLogo,
  HeaderWrapper,
  QuestionWrapper,
  PublicSurveyContentContainer,
  FooterButtonsWrapper,
  ButtonsWrapper,
  LanguageSelectWrapper,
  LanguageSelectContainer,
  AckInnerLabel,
  SurveyActionLogo,
  SurveyActionButton,
  RadioGroupInput,
  RadioGroupCircle,
  RadioGroupItem,
  RadioGroupItemRow,
  RadioGroupText,
  LanguageContainer,
  LanguageLabel,
  LanguageBtnContainer,
  ContentContainer,
};
